/**
 * `06 •• •• •• 12` : masque d'ÉCRAN d'un numéro de client, qui n'est jamais affiché en clair dans
 * le back-office (fiche client, détail d'un ticket du service client, où le backend l'applique
 * avant de répondre). Forme nationale pour un numéro français, sinon seuls les deux derniers
 * chiffres restent visibles. Le masque des JOURNAUX est ailleurs : `maskPhoneNumber` de
 * `@gozoki/sms` (`+33 6 ** ** ** 12`, via libphonenumber), fait pour distinguer deux destinataires
 * dans un log sans pouvoir les appeler.
 */
export const maskPhone = (phone: string | null | undefined): string | null => {
  if (!phone) return null
  const digits = phone.replace(/\D/g, '')
  if (digits === '') return null
  const national = phone.startsWith('+33') ? `0${digits.slice(2)}` : digits
  if (national.length === 10) {
    return `${national.slice(0, 2)} •• •• •• ${national.slice(8)}`
  }
  return `•• ${national.slice(-2)}`
}
